const language = state => state.language
const translations = state => state.translations

export default {
  language,
  translations
}
